import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dg-slider__text" }
const _hoisted_2 = { class: "dg-slider__input-wrapper" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "dg-slider__label" }
const _hoisted_5 = { class: "dg-slider__label-value" }

import { computed } from 'vue'

import { QuestionnaireView } from '@/models/onboarding'
import { DailyGoalChoice } from '@/models/onboarding.types'


export default /*@__PURE__*/_defineComponent({
  __name: 'DailyGoalSlider',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const selectedValue = computed(() => {
  return props.view.currentChoice as DailyGoalChoice
})

function updateChoice(event: Event): void {
  const target = event.target as HTMLInputElement
  props.view.setCurrentChoice(parseInt(target.value))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "dg-slider",
    style: _normalizeStyle({
      '--input-value-percent': `${selectedValue.value}%`,
      '--input-value-decimal': selectedValue.value / 100,
    })
  }, [
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode(_toDisplayString(selectedValue.value * 2) + " guides ", 1),
      _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
      _cache[1] || (_cache[1] = _createTextVNode("/ month", -1))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        type: "range",
        min: "1",
        max: "99",
        value: selectedValue.value,
        class: "dg-slider__input",
        onInput: updateChoice
      }, null, 40, _hoisted_3)
    ]),
    _createElementVNode("p", _hoisted_4, [
      _createElementVNode("strong", _hoisted_5, _toDisplayString(selectedValue.value), 1),
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "dg-slider__label-text" }, "min", -1))
    ])
  ], 4))
}
}

})